import { styled } from "@vebox/etui-system";
import { Li, LiProps } from "@vebox/etui-system-elements";
import { Theme } from "@vebox/etui-themes";

interface SuggestionProps extends LiProps {
	highlighted?: number;
}

export const Suggestion = styled(Li).attrs(
	({ highlighted, theme, ...props }: SuggestionProps): LiProps => {
		const th = theme as Theme;
		return {
			color: highlighted ? th.palette.action.active : th.palette.text.primary,
			bg: th.palette.common.white,
			borderTop: `1px solid ${th.palette.divider}`,
			p: `${th.spacing.sm}px ${th.spacing.md}px`,
			m: `0 ${th.spacing.sm}px`,
			...props,
		};
	},
)`
    cursor: pointer;
    text-align: left;
`;
